import { createStore } from 'vuex'
import api from '../api/index'

import { defaultForm } from './defaultForm'

export default createStore({
  state: {
    form: defaultForm,
    step: 0,
    subForm: 'main',
    user: {},
    isAdmin: false,
    settings: {}
  },
  getters: {
    progress: (state) => Math.floor(100 * state.step / state.form.steps),
    form: (state) => state.form
  },
  mutations: {
    setStepData: async function (state, stepData) {
      state.form[`step${stepData.step}`] = stepData
    },
    setStep: function (state, step) {
      state.form.currentStep = step
      localStorage.setItem('step', step)
    },
    setFormData: function (state, form) {
      state.form = form
    },
    setSubForm: function (state, subForm) {
      state.subForm = subForm
    },
    setUser: function (state, user) {
      state.user = user
    },
    setAdmin: function (state, isAdmin) {
      state.isAdmin = isAdmin
    },
    setPayment: function (state, payment) {
      state.user.payment = payment
    },
    setFormInWork: function (state, status) {
      state.form.formInWork = status
    },
    setSettings: function (state, settings) {
      state.settings = settings
    }
  },
  actions: {
    mainLoad: async function ({ commit, state, dispatch }) {
      const user = await api.queryFinnexAPI('/form/get', {
        phone: localStorage.getItem('phone'),
        form: state.form
      })
      const settingsData = await api.queryFinnexAPI('/settings/get', {
        key: 'tu7IaWkO37hNTFVN'
      })
      console.log('[mainLoad] ', user, settingsData)
      if (user.form.step11.docs.length === 0) user.form.step11.docs = [...api.attachments()]
      commit('setSettings', settingsData?.settings)
      commit('setFormData', user.form)
      commit('setUser', user)
    },
    saveForm: async function ({ commit, state, dispatch }) {
      const res = await api.queryFinnexAPI('/form/save', {
        _id: state.user._id,
        form: state.form
      })
    },
    saveSettings: async function ({ commit, state, dispatch }) {
      await api.queryFinnexAPI('/settings/save', state.settings)
    },
    resetForm: async function ({ commit, state, dispatch }) {
      commit('setFormData', defaultForm)
      localStorage.removeItem('phone')
      localStorage.removeItem('step')
      dispatch('saveForm')
    },
    formIsPaid: async function ({ commit, state, dispatch }, payment) {
      const _payment = {
        done: true,
        amount: payment.amount,
        coupon: payment.coupon,
        date: new Date(),
        paymentDetails: {type: 'coupon'}
      }
      const res = await api.queryFinnexAPI('/payment/save', {
        _id: state.user._id,
        payment: _payment
      })
      commit('setPayment', _payment)
    }
  },
  modules: {
  }
})
